export const sectors = [
  'Laboratório',
  'Setor do Pó',
  'Produção',
  'ETA',
  'Administrativo',
  'Opção 6',
  'Outro',
];

export const epiMotives = [
  'O anterior encontra-se danificado',
  'Perdi o anterior',
  'Mudei de setor',
  'Esqueci o meu em outro lugar',
  'Outro',
];

export const epiUrgencies = [
  'Imediato - Estou sem',
  'Médio - Ainda consigo usar o meu',
  'Aguardo - Apenas reposição periódica',
];

export const epiTypes = [
  { label: 'Máscara', hasCaixa: true },
  { label: 'Luvas', hasCaixa: true },
  { label: 'Capacete', hasCaixa: true },
  { label: 'Óculos', hasCaixa: true },
  { label: 'Botina sem cadarço', hasCaixa: true },
  { label: 'Botina com cadarço', hasCaixa: true },
  { label: 'Avental', hasCaixa: true },
  { label: 'Protetor Auditivo', hasCaixa: true },
  { label: 'Outro', hasCaixa: false },
];

export const incidentSectors = [
  'Produção',
  'ETA',
  'Laboratório',
  'Administrativo',
  'Setor do Pó',
  'Outro Setor',
];

export const incidentTypes = [
  'DERRAME PRODUTO - PEQ QUANT',
  'OCORRÊNCIA NA LESCADA',
  'CHOQUES ELÉTRICOS',
  'QUEIMADURAS',
  'DEIXE CAIR A MERCADORIA',
  'ALTURA',
  'OCORRÊNCIA NA EMPILHADEIRA',
  'TIVE UMA LESÃO NAS MÃOS',
  'TIVE UM ARRANHÃO',
  'Outro',
];

export const denunciationSectors = [
  'Laboratório',
  'Setor do Pó',
  'Produção',
  'ETA',
  'Administrativo',
  'Opção 6',
  'Outro',
];

export const harassmentTypes = [
  'Verbal descontextualizado - Questão sobre o incidente/interferência/persona, direito ou assunto inconexo, insinuação de que estão sendo descritos com linguagem ofensiva, palavrão, gesto, grito, apreciação verbais, ameaças, humilhações e com a mínima contumélia visível ou indireta.',
  'Verbal contextualizado - No escopo do tipo de assédio moral ocorre quando se assegura que poderá se basear no fato de que tal situação/persona ocorre com o uso de profissão ou função e fica a dever o uso pacifico.',
  'Hostilização - No caso de assédio moral institucional a violência ocorre entre pessoas de cargo e função e hierarquia de nível, desde o chefe até o colaborador, políticas de exclusão ou rotatividade de cargos específicos, deslocamentos de horários e atribuições, discriminação por razão de raça, sexo, origem, credo, opinião, religião.',
  'Ostracismo / Comunicacional - Submissão e uso de níveis organizacionais frente a transparência narrativa e integridade, consequência de eliminação, extermínio de palavras, truncamento da linguagem verbal, acordos não-consensuais perante a ocultação, exclusão e retirada como se fosse parte dos processos e relações interpessoais e/ou externa.',
  'Outro',
];